// services/api/studentService.js
import API from '../api/api';

export const adminService = {
  getAdmins: async () => {
    const response = await API.get('/get_admins');
    return response.data.data || [];
  },
  getAdminsLocations: async (admin_id) => {
    const response = await API.get('/get_admin_locations', { params: { admin_id}});
    return response.data.data || [];
  },
  deleteAdminStaff: async (id) => {
    const response = await API.post('/delete_admin_staff', { id });
    return response.data;
  },
  deleteAdminLocation: async (admin_id, location_id) => {
    const response = await API.post('/delete_admin_location', { admin_id, location_id });
    return response.data;
  },
  createAdminLocation: async (values) => {
    let response = await API.post('/create_admin_location', {...values});
    return response.data;
  },
  updateAdmin: async (values) => {
    let response = await API.post('/update_admin_staff', {...values});
    return response.data;
  },
  createAdmin: async (values) => {
    let response = await API.post('/create_admin_staff', {...values});
    return response.data;
  }
  
};


